<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { useDictStore } from '@/store/modules/dict'
const [name] = createNamespace('DictDisplay')
export default defineComponent({
  name,
  props: {
    value: {
      type: String as PropType<string>
    }
  },
  setup(props) {
    const dictStore = useDictStore()
    const text = computed(() => (props.value ? dictStore.word.get(props.value)?.label ?? '' : ''))
    return () => {
      return text.value
    }
  }
})
</script>
